var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesbubble1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/messages bubble 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.16786 13.5979C5.8129 13.5173 5.4648 13.3992 5.12977 13.2436C4.84394 13.1287 4.61042 13.0355 4.38873 13.0355C3.76974 13.0387 2.9988 13.641 2.59902 13.2398C2.19861 12.8381 2.79891 12.0652 2.79891 11.4403C2.79891 11.2173 2.70986 10.9867 2.59528 10.7005C1.70229 8.76354 2.04666 6.39543 3.64021 4.79711C5.67404 2.75578 8.97887 2.75578 11.0133 4.79711",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7265 13.2928C10.5072 13.8583 9.01704 13.6402 8.0107 12.6305C6.72603 11.3414 6.72354 9.24952 8.0107 7.958C9.29538 6.66895 11.3828 6.66895 12.6675 7.958C13.6732 8.96773 13.8911 10.4635 13.3269 11.687C13.2547 11.8676 13.1987 12.0132 13.1987 12.1537C13.1987 12.5487 13.5772 13.0366 13.3244 13.2903C13.0722 13.544 12.5852 13.1634 12.1948 13.1609C12.0541 13.1616 11.9065 13.2197 11.7265 13.2928Z",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesbubble1);
export default __webpack_public_path__ + "static/media/messages bubble 1.e2bbf57cc1a1a3933a12ab0e4936e589.svg";
export { ForwardRef as ReactComponent };